export default __webpack_public_path__ + "static/media/head_blue.080c3d09.png";